// export const hostname = "http://localhost:8080/api/v1"
export const hostname = process.env.REACT_APP_MULTIFOTA_URL+"/api/v1"
// export const hostname = "https://sandbox-multifota.tvilight.io/api/v1"
export const version = "v2.5.1"
// const adminEmail = "s.admin@tvilight.com"
const adminEmail = process.env.REACT_APP_ADMIN_EMAIL

const getEmailFromToken = () => {
    try {
        const token = localStorage.getItem('jwt_token');
        if (!token) return null;
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.sub ?? null;
    } catch {
        return null;
    }
};

export const getCurrentUserEmail = () => getEmailFromToken();
export const isAdmin = () => getEmailFromToken() === adminEmail;
export const deviceOTAStatusUrl = (imei, type, version,directOTA) => {
    return `${hostname}/device/${imei}/${type}/${version}/${directOTA}`
}
export const deviceBulkOTAStatusUrl = (imeiList) => {
    return `${hostname}/device/bulk/status/${imeiList}`
}